import { render, staticRenderFns } from "./ConfirmCard.vue?vue&type=template&id=6fa71596&scoped=true&lang=pug"
import script from "./ConfirmCard.vue?vue&type=script&lang=js"
export * from "./ConfirmCard.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCard.vue?vue&type=style&index=0&id=6fa71596&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa71596",
  null
  
)

export default component.exports